import range from 'lodash/range';

export default (currentYear: number, yearsCount: number) =>
  range(currentYear, currentYear - yearsCount);
